/*
 * @Author: jackshen
 * @Date: 2021-03-26 10:44:53
 * @LastEditors: wenlin
 * @LastEditTime: 2021-03-26 18:25:53
 * @Description:
 */
import request from '@/utils/request1'

export function points () {
  return request({
    url: '/api/papers/points',
    method: 'post'
  })
}

// 年份统计
export function getInstanceYears (data) {
  return request({
    url: '/api/papers/stats/year',
    method: 'post',
    data
  })
}
// language
export function getLanguage (data) {
  return request({
    url: '/api/papers/stats/language',
    method: 'post',
    data
  })
}
// subjectType
export function getSubject (data) {
  return request({
    url: '/api/papers/stats/subject',
    method: 'post',
    data
  })
}
// 期刊统计
export function getInstance (data) {
  return request({
    url: '/api/papers/stats/journal',
    method: 'post',
    data
  })
}
// 作者统计
export function getAuthor (data) {
  return request({
    url: '/api/papers/stats/author',
    method: 'post',
    data
  })
}
// 文献列表
export function getInstanceList (data) {
  return request({
    url: '/api/papers/find',
    method: 'post',
    data
  })
}
// 文献详情
export function getInstanceDetail (params) {
  return request({
    url: '/api/papers/' + params,
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/instance.js